import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import cockpit from './cockpit'
import humanRouters from './human'
import productRouters from './product'
import settingRouters from './setting'
import dataRouters from './dataManage'
import feicheRouters from './feiche'
import myhomeRouters from './myhome'
import ultimateRouters from './ultimate'
import financeRouters from './finance'
import trainRouters from './train'
import clientRouters from './client'
import { customDomainAndLogo } from '@/config/automatic'
import { openNavUrl, getConfigInfo } from '@/utils'

Vue.use(Router)

const requireRouter = require.context('.', false, /^(?!\.\/index|\.\/cockpit).*\.js$/)
let _routers = []

requireRouter.keys().forEach(fileName => {
  _routers = [..._routers, ...requireRouter(fileName).default]
})
// console.log('cockpit=', cockpit, _routers)
/* const haveVisitPermission = (path) => {
  let menus = (store.getters.CUSTOMER_GETMENU.datas || []).map(item => item.url)
  return menus.includes(path)
} */

export const specialRouters = [
  ...dataRouters, ...settingRouters, ...feicheRouters, ...ultimateRouters, ...financeRouters, ...trainRouters, ...productRouters,
  ...humanRouters, ...clientRouters

]
export const layoutRoute = [{
  path: '/',
  name: 'layout',
  component: () => import('@/views/layout'),
  children: [{
    path: '/404',
    name: 'notfind',
    component: () => import('@/views/notfind')
  }, {
    path: '/403',
    name: 'forbidden',
    component: () => import('@/views/forbidden')
  }, {
    path: '/k*',
    name: 'x5Page',
    component: () => import('@/views/x5')
  }, ..._routers]
}]

export const microRoute = {
  path: '/micro',
  name: 'layout-micro',
  component: () => import('@/views/microLayout'),
  children: [{
    path: '/q*',
    name: 'child-quote',
    component: () => import('@/views/child')
  }, {
    path: '/sho*',
    name: 'child-sx',
    component: () => import('@/views/child')
  }, {
    path: '/j*',
    name: 'child-java',
    component: () => import('@/views/child')
  }]
}

export const otherRouters = [{
  path: '/dataManage',
  name: 'dataManage',
  component: () => import('@/views/dataManage'),
  children: [...dataRouters]
}, {
  path: '/setting',
  name: 'setting',
  redirect: '/setting/index',
  component: () => import('@/views/setting'),
  children: [...settingRouters]
}, {
  path: '/feiche',
  name: 'feiche',
  component: () => import('@/views/feiche'),
  children: [...feicheRouters]
}, {
  path: '/myhome',
  name: '',
  component: () => import('@/views/myhome'),
  children: [...myhomeRouters]
}, {
  path: '/ultimate',
  name: 'ultimate',
  component: () => import('@/views/ultimate'),
  children: [...ultimateRouters]
}, {
  path: '/finance',
  name: 'finance',
  component: () => import('@/views/finance/index'),
  children: [...financeRouters]
}, {
  path: '/train',
  name: 'train',
  component: () => import('@/views/train/index'),
  children: [...trainRouters]
}, {
  path: '/product',
  name: 'product',
  redirect: '/product/index',
  component: () => import('@/views/product'),
  children: [...productRouters]
}, {
  path: '/hegui',
  name: 'hegui-layout',
  redirect: '/human',
  // component: () => import('@/views/hegui'),
  component: () => import('@/views/human.vue'),
  // component: () => import('@/views/newLayout/newUiLayout'), // 侧栏菜单布局测试
  children: [...humanRouters]
}, {
  path: '/client',
  name: 'client-layout',
  component: () => import('@/views/client.vue'),
  children: [{
    path: '/ck*',
    name: 'clientX5Page',
    component: () => import('@/views/x5')
  }, ...clientRouters]
}]

export const defaultRoutes = [{
  path: '/outer/insurance/import',
  name: 'outer-insurance-import',
  component: () => import('@/views/insurance/import')
}, {
  path: '/personnel/previewContractTemplate',
  component: () => import('@/views/personnel/previewContractTemplate'),
  name: 'personnel/previewContractTemplate',
  meta: {
    title: '合同预览'
  }
}, {
  path: '/login',
  name: 'login',
  component: () => import('@/views/login')
}, {
  path: '/page/login',
  name: 'jblsx-login',
  component: () => import('@/views/jblsx/login')
}, {
  path: '/zsl/login',
  name: 'zsl-login',
  component: () => import('@/views/zsl/login')
}, {
  path: '/authentication/:token',
  name: 'page-authentication',
  component: () => import('@/views/authentication')
}, {
  // AI合伙人 免登中转页(部署在 pre0)：新建工单取全新链接 → 换 token → 写 cookie → 跳 AI合伙人
  path: '/ai-partner-login',
  name: 'page-ai-partner-login',
  component: () => import('@/views/aiPartnerLogin')
}, {
  path: '/maintain',
  name: 'maintain',
  component: () => import('@/views/maintain')
}, {
  path: '/down',
  name: 'down',
  component: () => import('@/views/down')
}, {
  path: '/notice',
  name: 'notice',
  component: () => import('@/views/notice')
}, {
  path: '/feiche/mall',
  component: () => import('@/views/feiche/mall'),
  name: 'feiche-mall',
  meta: {
    title: '非车商城'
  }
}, {
  path: '/nlogin',
  name: 'nlogin',
  component: () => import('@/views/nlogin')
}, ...cockpit]

// const partner = localStorage.getItem('latestPartner')
// const latestPartner = (partner && JSON.parse(partner)) || [''] // 针对 zsl 类型处理
const itemInfo = getConfigInfo()
const haveCustomConfig = customDomainAndLogo.some(item => location.host.includes(item.subdomain) || (itemInfo && itemInfo.subdomain === item.subdomain))

let router = new Router({
  mode: 'history',
  routes: [...defaultRoutes],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
router.beforeEach(async (to, from, next) => {
  // console.log('to = ', to, from)
  const isNoLogin = to.path.includes('/authentication/') || to.path.includes('/ai-partner-login')
  if (!isNoLogin && !['/login', '/page/login', '/zsl/login'].includes(to.path) && (!store.getters.CUSTOMER_LOGINCUSTOMER || !store.getters.CUSTOMER_LOGINCUSTOMER.data)) {
    await store.dispatch('customerLoginCustomer')
  }
  const env = process.env.NODE_ENV
  const paths = customDomainAndLogo.map(item => item.path)
  if (env !== 'development') {
    const subdomain = (itemInfo && itemInfo.subdomain) || ''
    const item = itemInfo // customDomainAndLogo.find(item => item.subdomain === subdomain)
    if (paths.includes(to.path) && !haveCustomConfig) {
      next('/login')
    } else if (to.path === '/login' && haveCustomConfig) {
      next(item.path || '/page/login')
    } else if (to.path === '/' && haveCustomConfig) {
      const prefix = location.host.split('.')[0]
      const host = `${env === 'production' ? '' : `${prefix}.`}cxv3-new.youbaolian.top`
      openNavUrl(`/?subdomain=${subdomain}`, '', host, 'self', false)
      next()
    }
  }
  const menus = (store.getters.CUSTOMER_GETMENU.datas || []).filter(item => item.url).map(item => item.url)
  const keepIncludes = store.getters.keepIncludes
  if (menus.includes(to.path)) {
    const keepAliveList = ['/feiche/policy', '/personnel/salesList', '/salary/attendance']
    !keepIncludes.includes(to.name) && keepAliveList.includes(to.path) && keepIncludes.push(to.name)
    const index = keepIncludes.indexOf(from.name)
    index !== -1 && keepIncludes.splice(index, 1)
  }
  store.dispatch('setIncludes', keepIncludes)

  // const dynamicRoutes = store.getters.dynamicRoutes
  // console.log('🚀 ~ file: index.js:202 ~ router.beforeEach ~ dynamicRoutes:', dynamicRoutes, router)
  const routes = router.options.routes
  const index = routes.findIndex(item => item.path === '/')
  const loginPaths = ['/login', ...paths]
  if (index === -1 && !loginPaths.includes(to.path)) {
    store.dispatch('changeRoutes', [])
    next({...to})
  } else if (loginPaths.includes(to.path)) {
    store.dispatch('resetRoutes')
  }
  next()
})
router.afterEach((to, from, next) => {
  // console.log(to, from, location.host)

  // 判断是否是登录页面
  const isLogin = ['/login', '/page/login'].includes[to.path]
  // 判断是否通过免登录链接进入
  const isNoLogin = to.path.includes('/authentication/') || to.path.includes('/ai-partner-login')
  if (!isLogin && !isNoLogin && process.env.NODE_ENV !== 'development') {
    console.log('store = ', store)
    let userInfo = store.getters.CUSTOMER_LOGINCUSTOMER.data
    if (userInfo) {
      let params = {
        dtoList: [{
          partnerId: userInfo.PartnerId, // 商户ID
          customerId: userInfo.CustomerId, // 用户ID
          organizationId: userInfo.OrganizationId, // 组织ID
          roleId: userInfo.RoleIds, // 角色id
          ticket: '', // 授权ticket
          title: `${to.meta.title}`, // 网页title名称
          ip: '', // city.cip, // 192.135.0.1
          address: '', // city.cname, // 湖北武汉
          httpAddress: `${location.origin}${to.path}`, // 当前http地址
          source: 1// 来源 1是核心系统 2是非车 3是营销版
        }]
      }
      store.dispatch('clickrates', params)
    }
  }
  // next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js